export const TableLoading = () => {
  return (
    <div className="overlay bg-transparent md:left-[270px]" data-testid="table-loading">
      <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
